export const skill_development = {
  id: 3,
  name: "Skills Development",
  slug: "skill_development",
  status: "at risk",
  description: "Training programmes, learnerships, and skills development levy compliance",
  deadline: "31 Jan 2026",
  current_points: 18.2,
  total_points: 25,
  target: 22,
  workflow_completed: 2,
  workflow_total: 7,
  icon: "fas fa-graduation-cap",
  theme: { gradientFrom: "#a855f7", gradientTo: "#ec4899" },
  steps: [
    {
      id: "sd-1",
      title: "Compile Training Needs Analysis",
      description: "Identify skills gaps and training requirements across all occupation levels",
      status: "completed",
      due: "05 Jan 2026",
      owner_initials: "NM",
      owner_name: "Nomsa Mthembu",
      owner_role: "Training Manager",
      owner_email: "nomsa.mthembu@company.co.za",
      owner_number: "+27 85 456 7890",
      owner_role_desc: "Manages training programs and skills development",
      required_documents: ["Training Needs Analysis Report", "Skills Gap Assessment"],
    },
    {
      id: "sd-2",
      title: "Submit WSP & ATR to SETA",
      description: "Complete and submit Workplace Skills Plan and Annual Training Report",
      status: "overdue",
      due: "30 Apr 2025",
      owner_initials: "NM",
      owner_name: "Nomsa Mthembu",
      owner_role: "Training Manager",
      owner_email: "nomsa.mthembu@company.co.za",
      owner_number: "+27 85 456 7890",
      owner_role_desc: "Manages training programs and skills development",
      required_documents: ["WSP Submission", "ATR Submission", "SETA Confirmation"],
    },
    {
      id: "sd-3",
      title: "Register Learnerships & Internships",
      description:
        "Register qualifying learnerships, internships, and bursaries",
      status: "in_progress",
      due: "25 Jan 2026",
      owner_initials: "NM",
      owner_name: "Nomsa Mthembu",
      owner_role: "Training Manager",
      owner_email: "nomsa.mthembu@company.co.za",
      owner_number: "+27 85 456 7890",
      owner_role_desc: "Manages training programs and skills development",
      required_documents: ["Learnership Agreements", "Internship Agreements"],
    },
    {
      id: "sd-4",
      title: "Compile Training Evidence",
      description:
        "Collect attendance registers, invoices, and proof of payment",
      status: "pending",
      due: "27 Jan 2026",
      owner_initials: "FN",
      owner_name: "Finance Team",
      owner_role: "Accounts",
      owner_email: "finance.team@company.co.za",
      owner_number: "+27 91 912 3456",
      owner_role_desc: "Manages payroll and financial reporting",
      required_documents: ["Training Registers", "Invoices", "Proof of Payment"],
    },
    {
      id: "sd-5",
      title: "Calculate Skills Development Spend",
      description:
        "Calculate total spend on black employees against leviable amount",
      status: "pending",
      due: "28 Jan 2026",
      owner_initials: "LZ",
      owner_name: "Lindiwe Zulu",
      owner_role: "BEE Consultant",
      owner_email: "lindiwe.zulu@beeconsultants.co.za",
      owner_number: "+27 89 890 1234",
      owner_role_desc: "Provides BEE score calculations and compliance advice",
      required_documents: ["Skills Spend Calculation", "Payroll Summary"],
    },
    {
      id: "sd-6",
      title: "Prepare Skills Development Summary",
      description:
        "Prepare summary report and points calculation",
      status: "pending",
      due: "30 Jan 2026",
      owner_initials: "LZ",
      owner_name: "Lindiwe Zulu",
      owner_role: "BEE Consultant",
      owner_email: "lindiwe.zulu@beeconsultants.co.za",
      owner_number: "+27 89 890 1234",
      owner_role_desc: "Provides BEE score calculations and compliance advice",
      required_documents: ["Summary Report"],
    },
    {
      id: "sd-7",
      title: "Submit Skills Development Pack",
      description:
        "Submit complete skills development evidence pack for verification",
      status: "pending",
      due: "31 Jan 2026",
      owner_initials: "JD",
      owner_name: "John Dlamini",
      owner_role: "BEE Manager",
      required_documents: ["Complete Skills Pack"],
    },
  ],
};
